import { render, staticRenderFns } from "./CategoriaChip.vue?vue&type=template&id=51c07ff9&scoped=true"
import script from "./CategoriaChip.vue?vue&type=script&lang=js"
export * from "./CategoriaChip.vue?vue&type=script&lang=js"
import style0 from "./CategoriaChip.vue?vue&type=style&index=0&id=51c07ff9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c07ff9",
  null
  
)

export default component.exports